import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { WebEntryLayout } from './entryHelpers';

export default function PatRegStartScreen() {
  const navigate = useNavigate();

  return (
    <WebEntryLayout>
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '48px 28px 40px',
        fontFamily: T.font,
        boxSizing: 'border-box',
        width: '100%',
      }}
    >
      <div style={{ fontSize: 22, fontWeight: 800, color: T.navy, textAlign: 'center' }}>
        Register as Patient
      </div>
      <div style={{ fontSize: 13, color: T.textSec, textAlign: 'center', lineHeight: 1.7, marginTop: 8, maxWidth: 320 }}>
        Create your NeoHealthCard health identity. Your records stay consent-based. Every access is logged.
      </div>

      {/* User icon */}
      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: 24,
          background: `${T.teal}1A`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 32,
        }}
      >
        <svg width={36} height={36} viewBox="0 0 24 24" fill="none" stroke={T.teal} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
          <circle cx={12} cy={7} r={4} />
        </svg>
      </div>

      <div style={{ flex: 1 }} />

      {/* Start Registration button */}
      <button
        onClick={() => navigate('/patient/register/basic')}
        style={{
          width: '100%',
          maxWidth: 340,
          padding: '15px 0',
          background: `linear-gradient(135deg, ${T.teal}, ${T.overlap})`,
          color: T.white,
          border: 'none',
          borderRadius: 14,
          fontSize: 15,
          fontWeight: 700,
          fontFamily: T.font,
          cursor: 'pointer',
        }}
      >
        Start Registration
      </button>

      <div style={{ fontSize: 10, color: T.textTer, textAlign: 'center', lineHeight: 1.7, marginTop: 14, maxWidth: 320 }}>
        Patient does not need doctor approval. Your NeoHealthCard ID is generated after OTP verification.
      </div>
    </div>
    </WebEntryLayout>
  );
}
